import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login.vue'
import Reg from '@/views/Reg.vue'
import Home from '@/views/Home.vue'
import Forget from '@/views/Forget.vue'
import ApiMarket from '@/views/ApiMarket.vue'
import Layout from '@/views/Layout.vue'
import ApiMarketDetail from '@/views/ApiMarketDetail.vue'
import UserLayout from '@/views/UserLayout.vue'
import DataCenter from '@/views/DataCenter.vue'
import MyApi from '@/views/MyApi.vue'
import ApplyApi from '@/views/ApplyApi.vue'
import MyOrder from '@/views/MyOrder.vue'
import UpdatePwd from '@/views/UpdatePwd.vue'
import ResourceDownload from '@/views/ResourceDownload.vue'
import OtherResourceDownload from '@/views/OtherResourceDownload.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
    component: Layout,
    children:
      [
        { path: '/home', component: Home },
        { path: '/apiMarget', component: ApiMarket },
        { path: '/apiMargetDetail/:id', component: ApiMarketDetail },
        { path: '/resourceDownload', component: ResourceDownload },
        { path: '/otherResourceDownload', component: OtherResourceDownload },
        {
          path: '/userLayout',
          component: UserLayout,
          redirect: 'dataCenter',
          children: [
            { path: '/dataCenter', component: DataCenter },
            { path: '/myApi', component: MyApi },
            { path: '/applyApi', component: ApplyApi },
            { path: '/myOrder', component: MyOrder },
            { path: '/updatePwd', component: UpdatePwd }
          ]
        }
      ]
  },
  { path: '/login', component: Login },
  { path: '/forget', component: Forget },
  { path: '/reg', component: Reg }

]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
